export default __webpack_public_path__ + "static/media/DAIF_Extra3_Screen1_in-end.0ac2e118.jpg";